import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedMember, clearSelectedMember } from "@/store/authSlice";
import { RootState } from "@/store";
import { useManagedMembersContext } from "@/context/ManagedMembersContext";
import { setNavigationSource } from "@/utils/navigationSource";
import FamilyOverview from "./FamilyOverview";

const HealthProfilesOverview: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const loggedInMember = useSelector((state: RootState) => state.auth.member);
  const { managedMembers } = useManagedMembersContext();

  // Clear selectedMember when overview screen loads
  useEffect(() => {
    dispatch(clearSelectedMember());
    localStorage.removeItem("selectedMember");
  }, [dispatch]);

  const handleMemberAction = (memberId: string, action: string) => {
    // Find the member object from managedMembers
    const member = managedMembers.find((m) => m.id === memberId);

    // Update selectedMember in Redux (like profile picker does)
    if (member) {
      if (member.id === loggedInMember?.id) {
        dispatch(clearSelectedMember());
      } else {
        dispatch(setSelectedMember(member));
      }
    }

    if (action === "navigate") {
      // Set navigation source to current overview page
      setNavigationSource("overview", window.location.pathname);
      navigate("/profile/emergency-card/activate", {
        state: { memberId, backUrl: window.location.pathname },
      });
    }
  };

  return (
    <FamilyOverview
      type="health-profiles"
      onMemberAction={handleMemberAction}
    />
  );
};

export default HealthProfilesOverview;
